import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import CompleteTransactions from "./complete";
import ScheduledTransactions from "./scheduled";
import CanceledTransactions from "./canceled";
import AchDebitRequests from "./achDebitRequests";
import { backendGetRequest } from "../../../helpers/callBackend";
import FormattedTabs from "../../generic/formattedTabs";
import CircularProgress from '@mui/material/CircularProgress';

const internalAccountSources = ['UN'];

const Transactions = (props) => {
    const [completeTransactions, setCompleteTransactions] = useState(props.transactionsTable);
    const [pendingTransactions, setPendingTransactions] = useState(props.pendingTable);
    const [scheduledTransactions, setScheduledTransactions] = useState(props.scheduledTable);
    const [canceledTransactions, setCanceledTransactions] = useState(props.canceledTable);
    const [loadingIncompleteTransactions, setLoadingIncompleteTransactions] = useState(props.loadingIncompleteTransactions);
    const [loadingTransactions, setLoadingTransactions] = useState(props.loadingTransactions);
    const [canceledCompletedTxn, setCanceledCompletedTxn] = useState(false);
    const [customCategories, setCustomeCategories] = useState([]);
    const TXN_TAG = 2;

    useEffect(() => {
        setCompleteTransactions(props.transactionsTable);
    }, [props.transactionsTable]);

    useEffect(() => {
        setPendingTransactions(props.pendingTable);
    }, [props.pendingTable]);

    useEffect(() => {
        setScheduledTransactions(props.scheduledTable);
    }, [props.scheduledTable]);

    useEffect(() => {
        setCanceledTransactions(props.canceledTable);
    }, [props.canceledTable]);

    useEffect(() => {
        setLoadingIncompleteTransactions(props.loadingIncompleteTransactions);
    }, [props.loadingIncompleteTransactions]);

    useEffect(() => {
        setLoadingTransactions(props.loadingTransactions);
    }, [props.loadingTransactions]);

    useEffect(() => {
        backendGetRequest(
            "/api/generic-tag/",
            { params: { group_type: TXN_TAG } },
            "loadingCustomCategories",
        ).then((res) => {
            setCustomeCategories(res?.data?.generic_tags);
        });
    }, [])

    const cancelPendingTransaction = (id, updatePendingInChild) => {
        const newPendingTransactions = pendingTransactions.filter(transaction => transaction.id !== id);
        const canceledTransaction = pendingTransactions.find(transaction => transaction.id === id);
        setPendingTransactions(newPendingTransactions);
        setCanceledTransactions([...canceledTransactions, canceledTransaction]);
        updatePendingInChild();
    };

    const cancelScheduledTransaction = (id, updateScheduledInChild) => {
        const newScheduledTransactions = scheduledTransactions.filter(transaction => transaction.id !== id);
        const canceledTransaction = scheduledTransactions.find(transaction => transaction.id === id);
        setScheduledTransactions(newScheduledTransactions);
        setCanceledTransactions([...canceledTransactions, canceledTransaction]);
        updateScheduledInChild();
    };

    const cancelCompletedTransaction = (id, updateCompletedInChild) => {
        const newCompletedTransactions = completeTransactions.filter(transaction => transaction.id !== id);
        const canceledTransaction = completeTransactions.find(transaction => transaction.id === id);
        const modifiedCanceledTransaction = {
            id: canceledTransaction.id,
            attributes: {
                createdAt: canceledTransaction.timestamp,
                description: canceledTransaction.description,
                amount: canceledTransaction.amount,
            },
            type: canceledTransaction.transaction_code,
            counterparty_name: canceledTransaction.counterparty_name,
        };
        setCompleteTransactions(newCompletedTransactions);
        setCanceledTransactions([...canceledTransactions, modifiedCanceledTransaction]);
        setCanceledCompletedTxn(true);
        updateCompletedInChild();
    };

    let completeTransactionsComponent = <CompleteTransactions
        onLoadTransactions={props.onLoadTransactions}
        transactionsLoading={props.transactionsLoading}
        currentMonth={props.currentMonth}
        currentYear={props.currentYear}
        completeTransactions={completeTransactions}
        pendingTransactions={pendingTransactions}
        canceledTransactions={canceledTransactions}
        completeTransactionsNumerator={props.completeTransactionsNumerator}
        completeTransactionsDenominator={props.completeTransactionsDenominator}
        cancelPendingTransaction={cancelPendingTransaction}
        cancelCompletedTransaction={cancelCompletedTransaction}
        loadingIncompleteTransactions={loadingIncompleteTransactions}
        loadingTransactions={loadingTransactions}
        bankAccountName={props.bankAccountName}
        bankAccountDescription={props.bankAccountDescription}
        bankAccountId={props.bankAccountId}
        portfolioName={props.portfolioName}
        propertyName={props.propertyName}
        apiSource={props.apiSource}
        customCategories={customCategories}
        paymentRequests={props.paymentRequests}
        updatePaymentRequests={props.updatePaymentRequests}
        loadingPaymentRequests={props.loadingPaymentRequests}
        onRecalibrate={props.onRecalibrate}
    />;

    return (
        <>
            {internalAccountSources.includes(props.apiSource) ?
                <FormattedTabs
                    defaultActiveKey={0}
                    tabPanes={[
                        {
                            "title": "Completed",
                            "key": 0,
                            "body": completeTransactionsComponent,
                        },
                        {
                            "title": "Scheduled",
                            "key": 1,
                            "body": (
                                <ScheduledTransactions
                                    transactions={scheduledTransactions}
                                    cancelScheduledTransaction={cancelScheduledTransaction}
                                    bankAccountName={props.bankAccountName}
                                    loadingIncompleteTransactions={props.loadingIncompleteTransactions}
                                />
                            ),
                        },
                        {
                            "title": "Canceled",
                            "key": 2,
                            "body": (
                                <CanceledTransactions
                                    transactions={canceledTransactions}
                                    bankAccountName={props.bankAccountName}
                                    isCompletedTxn={canceledCompletedTxn}
                                    loadingIncompleteTransactions={props.loadingIncompleteTransactions}
                                />
                            ),
                        },
                        {
                            "title": "Requests",
                            "key": 3,
                            "body":
                                props.loadingAchDebitRequests ?
                                    (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
                                            <CircularProgress />
                                        </div>
                                    ) : (
                                        <AchDebitRequests
                                            achDebitRequests={props.achDebitRequestsTable}
                                            loadingAchDebitRequests={props.loadingAchDebitRequests}
                                            cancelAchDebitRequest={props.cancelAchDebitRequest}
                                        />
                                    )
                            ,
                            "disabled": props.loadingAchDebitRequests || props.achDebitRequestsTable.length === 0,
                        },
                    ]}

                />
                :
                <div style={{ marginTop: "50px" }}>
                    {completeTransactionsComponent}
                </div>
            }
        </>
    )
}

export default Transactions;